module.exports = new __parcel__URL__("hitHurt.a9e44968.wav").toString();